import { Badge, IconButton, Tooltip } from '@mui/material';
import { Notifications } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ROUTES } from '../../../router/routes-definitions';

export const LayoutNotifications = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Tooltip title={t('navigation.notifications')}>
      <IconButton color="inherit" onClick={() => navigate(ROUTES.NOTIFICATIONS)}>
        <Badge badgeContent={3} color="warning">
          <Notifications />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};
